<template>
  <div class="my-auto mr-3 inline-flex items-center gap-2">
    <span class="mb-0! px-0! text-xs! font-normal! text-[#A7A598]! normal-case!">
      Preview as User:
    </span>
    <span class="mb-0! inline-flex h-8! items-center gap-1 px-0!">
      <RfInput
        v-model="liquidPreviewUserId"
        size="small"
        placeholder="Enter User ID"
        class="[&>span]:border-beige-30 [&>span]:m-0! [&>span]:border [&>span]:border-solid [&>span]:bg-transparent! [&>span]:p-0!"
      >
        <template #append>
          <component
            :is="liquidPreviewUserId ? 'button' : 'span'"
            class="m-0! inline-flex h-6! w-6! p-0!"
            @click="() => ((liquidPreviewUserId = ''), (userData = {}), (liquidContextStore.previewUserContext.value = {}))"
          >
            <RfCloseIcon
              class="fill-white-1! m-auto! h-6! w-6! p-0!"
              :class="{ 'opacity-0': !liquidPreviewUserId }"
            />
          </component>
        </template>
      </RfInput>

      <button
        class="hover:bg-white-1/30 active:bg-white-1/40 h-full rounded-lg bg-white/20 px-3 py-1 text-xs text-white"
        @click="onUpdate"
      >
        Update
      </button>
      <button
        title="Preview as random user"
        class="hover:bg-white-1/30 active:bg-white-1/40 m-0! ml-2! inline-flex aspect-square h-full rounded-lg p-0!"
        @click="onRandom"
      >
        <RfRandomIcon class="fill-white-1! m-auto! h-6! w-6! p-0!" />
      </button>
    </span>
  </div>
</template>

<script setup>
import RfCloseIcon from "@/components/icons/RfCloseIcon.vue";
import RfRandomIcon from "@/components/icons/RfRandomIcon.vue";
import RfInput from "@/components/inputs/RfInput.vue";
import { useEndUserStore } from "@/pinia/endUserStore";
import { useLiquidContextStore } from "@/pinia/liquidContextStore";
import { useToastsStore } from "@/pinia/toastsStore";
import { ref } from "vue";

const props = defineProps({ appId: String });
const userData = defineModel("userData", { type: Object, default: () => ({}) });
const liquidPreviewUserId = ref("");
const endUserStore = useEndUserStore();
const liquidContextStore = useLiquidContextStore();
const toastsStore = useToastsStore();

const onUpdate = async () => {
  if (!liquidPreviewUserId.value)
    return toastsStore.create({
      type: "error",
      body: "Please enter a valid User ID",
    });

  const userDataIn = await endUserStore.getActions({
    appId: props.appId,
    userId: liquidPreviewUserId.value,
    waitForTraits: true,
    returnValue: true,
  });
  userData.value = userDataIn?.traits || {};
  liquidContextStore.previewUserContext.value = userData.value;
  return userData.value;
};

const onRandom = async () => {
  if (!endUserStore.results.length) {
    await endUserStore.search({ query: "label=rf_test_user&value=true", appId: props.appId });
  }
  if (!endUserStore.results.length) {
    return toastsStore.create({
      type: "error",
      body: "No end users found for this application",
    });
  }
  const randomIndex = Math.floor(Math.random() * endUserStore.results.length);
  const randomUser = endUserStore.results[randomIndex];
  liquidPreviewUserId.value = randomUser.user_uid;
  return onUpdate();
};
</script>
